const BASE_SIZE = 20

export class SafariImageHandler {
  constructor(imageElement, preserve = false) {
    this.image = imageElement
    this.observer = null
    this.preserve = preserve
    this.boundCheckAndAdjustSize = this.checkAndAdjustSize.bind(this)
  }

  init() {
    this.checkAndAdjustSize()
    this.setupObserver()
    this.image.addEventListener('load', this.boundCheckAndAdjustSize)
  }

  checkAndAdjustSize() {
    if (this.isValidSrc) {
      if (this.imageNeedsAdjusting) {
        this.image.style.width = '100%'
        this.image.style.height = '100%'

        setTimeout(() => {
          this.cleanup()
        }, 200)
      }
      else {
        this.cleanup()
      }
    }
  }

  setupObserver() {
    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes'
          && (mutation.attributeName === 'src'
            || mutation.attributeName === 'style')) {
          this.checkAndAdjustSize()
        }
      })
    })

    const config = { attributes: true, attributeFilter: ['src', 'style'] }
    this.observer.observe(this.image, config)
  }

  cleanup() {
    if (!this.imageNeedsAdjusting) {
      this.image.style.width = ''
      this.image.style.height = ''

      if (this.observer && !this.preserve) {
        this.observer.disconnect()
      }

      this.image.removeEventListener('load', this.boundCheckAndAdjustSize)
    }
    else {
      this.checkAndAdjustSize()
    }
  }

  get isValidSrc() {
    return this.image.getAttribute('src') != null
      && this.image.getAttribute('src').trim() !== ''
  }

  get imageNeedsAdjusting() {
    const rect = this.image.getBoundingClientRect()

    if (rect.width < BASE_SIZE || rect.height < BASE_SIZE) {
      return true
    }
    else {
      return false
    }
  }
}
